import { render, staticRenderFns } from "./StandardUsersDropdown.vue?vue&type=template&id=6041c9fd&"
import script from "./StandardUsersDropdown.vue?vue&type=script&lang=js&"
export * from "./StandardUsersDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports